import { render } from "./RewriteInternalProductsModal.vue?vue&type=template&id=2bb4653c"
import script from "./RewriteInternalProductsModal.vue?vue&type=script&lang=js"
export * from "./RewriteInternalProductsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__